import React, { Component } from "react";
import { NavBar, SideBar, Footer, Scanner } from "../../components";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import Switch from "react-input-switch";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import produtoModel from "../../models/produto";
import usuarioModel from "../../models/usuario";
import historicoPedidoModel from "../../models/historicoPedido";
import familiaProdutoModel from "../../models/familiaProduto";
import grupoProdutoModel from "../../models/grupoProduto";
import vendedorModel from "../../models/vendedor";
import moment from "moment";
import queryString from "query-string";
import Select from "react-select";
import axios from "axios";
const {
  formatarReal,
  formatarCasaDecimal,
  formatarRealCarrinho,
} = require("../../utils");
PouchDB.plugin(PouchdbFind);
let VALIDAR_ESTOQUE = localStorage.getItem("validarEstoque");
if (VALIDAR_ESTOQUE === null) {
  VALIDAR_ESTOQUE = true;
} else {
  VALIDAR_ESTOQUE = VALIDAR_ESTOQUE === "true" ? true : false;
}

export default class AdicionarItem extends Component {
  constructor(props) {
    super(props);
    this.loadUsuario = this.loadUsuario.bind(this);
    this.loadPedido = this.loadPedido.bind(this);
    this.toggle = this.toggle.bind(this);
    this.load = this.load.bind(this);
    this.onChangePrecoFinal = this.onChangePrecoFinal.bind(this);
    this.handleChangeInputValores = this.handleChangeInputValores.bind(this);
    this.validaDescAcrescimoOver = this.validaDescAcrescimoOver.bind(this);
    this.getTipoAtualValor1 = this.getTipoAtualValor1.bind(this);
    this.handleChangeQtd = this.handleChangeQtd.bind(this);
    this.adicionarItens = this.adicionarItens.bind(this);
    this.onChangeQueryBusca = this.onChangeQueryBusca.bind(this);
    this.buscar = this.buscar.bind(this);
    this.limparBusca = this.limparBusca.bind(this);
    this.handleClickValores = this.handleClickValores.bind(this);
    this.abrirProdutoDetalhe = this.abrirProdutoDetalhe.bind(this);
    this.onChangeInputModal = this.onChangeInputModal.bind(this);
    this.changeBlurQtd = this.changeBlurQtd.bind(this);
    this.onClickButtonQtd = this.onClickButtonQtd.bind(this);
    this.calcularTotalCarrinho = this.calcularTotalCarrinho.bind(this);
    this.calcularValorDesconto = this.calcularValorDesconto.bind(this);
    this.carregarHistoricoProduto = this.carregarHistoricoProduto.bind(this);
    this.onDetected = this.onDetected.bind(this);
    this.loadParametros = this.loadParametros.bind(this);
    this.loadFamiliasProduto = this.loadFamiliasProduto.bind(this);
    this.loadGruposProduto = this.loadGruposProduto.bind(this);
    this.toggleModalFiltro = this.toggleModalFiltro.bind(this);
    this.handleChangeFiltro = this.handleChangeFiltro.bind(this);
    this.limparFiltros = this.limparFiltros.bind(this);
    this.handleClickFiltrar = this.handleClickFiltrar.bind(this);
    this.getComissaoProduto = this.getComissaoProduto.bind(this);
    this.toggleModalObsItem = this.toggleModalObsItem.bind(this);
    this.handleClickObsItemNovo = this.handleClickObsItemNovo.bind(this);
    this.handleChangeInputObsItemNovo =
      this.handleChangeInputObsItemNovo.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);
    // this.handleChangeFiltro = this.handleChangeFiltro.bind(this);
    // this.onChangeFilters = this.onChangeFilters.bind(this);
    // this.toggleProduto = this.toggleProduto.bind(this);
    // this.clearFilters = this.clearFilters.bind(this);
    // this.loadFilters = this.loadFilters.bind(this);

    this.state = {
      idPedido: null,
      actionPage: "CADASTRAR",
      produtos: [],
      pedido: null,
      queryBusca: "",
      vendedor: null,
      skip: 0,
      hasMore: true,
      buscaAtivada: false,
      modal: false,
      produtoSelecionado: null,
      db: null,
      listaProdutos: [],
      valorTotalCarrinho: 0,
      mensagemBusca: "",
      exibirLoading: false,
      isInputAlterado: false,
      camera: false,
      result: null,
      abaAtiva: "itens", //itens, camera
      buscaPadrao: "descricao", //descricao, cdBarras
      usuario: null,
      parametros: null,
      // modalFilter: false,
      // filtro: {
      //   familia: false,
      //   grupo: false
      // },
      // familia: null,
      // grupo: null,
      // itensFamilia:[],
      // itensGrupo:[],
      modalFiltro: false,
      filtroModal: {
        familia: null,
        grupo: null,
      },
      familias: [],
      grupos: [],
      tipoPesquisa: "cod", // cod, desc
      exibirBotao: true,
      pesquisaProdutoPalavraChave: true,
      opcoes: [
        {
          label: "Sim",
          value: "1",
        },
        {
          label: "Não",
          value: "0",
        },
      ],
      opcaoSelecionada: {
        label: "Sim",
        value: "1",
      },
      listaComissoes: [],
      modalObsItem: false,
      idProdutoSelecionadoObs: null,
      obsItemSelecionado: "",
    };
  }

  async componentDidMount() {
    this.verificaAutenticacao();
    let idPedido = queryString.parse(this.props.location.search).id;
    let actionPage = this.state.actionPage;
    if (idPedido !== undefined) {
      actionPage = "EDITAR";
    }

    localStorage.setItem("existeProdutoAdicionado", "false");
    let tipoPesquisa = localStorage.getItem("tipoPesquisa");

    if (tipoPesquisa === null) {
      tipoPesquisa = "cod";
      localStorage.setItem("tipoPesquisa", tipoPesquisa);
    }

    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });
    await this.setState(
      {
        db: db,
        tipoPesquisa,
        idPedido,
        actionPage,
      },
      async () => {
        await this.loadUsuario();
        await this.loadParametros();
        await this.loadPedido();

        localStorage.setItem("lastPage", "adicionarItens");
        this.calcularTotalCarrinho();
        await this.loadFamiliasProduto();
        await this.loadGruposProduto();

        let pesquisaProdutoPalavraChave = localStorage.getItem(
          "pesquisaProdutoPalavraChave"
        );
        if (pesquisaProdutoPalavraChave !== null) {
          pesquisaProdutoPalavraChave =
            pesquisaProdutoPalavraChave === "true" ? true : false;
          let opcaoSelecionada = this.state.opcaoSelecionada;
          if (pesquisaProdutoPalavraChave) {
            opcaoSelecionada = {
              label: "Sim",
              value: "1",
            };
          } else {
            opcaoSelecionada = {
              label: "Não",
              value: "0",
            };
          }
          this.setState({ pesquisaProdutoPalavraChave, opcaoSelecionada });
        }

        await this.load(false, false);
      }
    );
  }

  async loadUsuario() {
    const localUsuario = await usuarioModel.find(this.state.db);
    await this.setState({ usuario: localUsuario });
  }

  async loadParametros() {
    let query = {
      selector: {
        type: { $eq: "parametros" },
      },
      limit: 1,
    };

    let result = await this.state.db.find(query);
    let parametros = result.docs[0];

    this.setState({ parametros });
  }

  async loadPedido() {
    let pedidoStorage = null;
    if (this.state.actionPage === "CADASTRAR") {
      pedidoStorage = localStorage.getItem("pedido");
    } else if (this.state.actionPage === "EDITAR") {
      pedidoStorage = localStorage.getItem("orcamento");
    }
    if (pedidoStorage !== null) {
      let pedidoSaldo = JSON.parse(pedidoStorage);

      let descontoTotal = 0;
      let acrescimoTotal = 0;

      for (let itemProduto of pedidoSaldo.itens) {
        if (itemProduto.produto.preco.valorAcrescimo > 0) {
          acrescimoTotal +=
            itemProduto.produto.preco.valorAcrescimo *
            parseFloat(itemProduto.quantidade);
        }

        if (itemProduto.produto.preco.valorDesconto > 0) {
          descontoTotal +=
            itemProduto.produto.preco.valorDesconto *
            parseFloat(itemProduto.quantidade);
        }
      }

      let vendedorFind = await vendedorModel.buscarPorIdIntegracao(
        this.state.db,
        pedidoSaldo.cliente.vendedor.idIntegracao
      );

      // let novoSaldo = vendedorFind.vlOver - descontoTotal;
      // novoSaldo += acrescimoTotal;
      // vendedorFind.vlOver = novoSaldo;

      let listaComissoes = this.state.listaComissoes;

      if (
        vendedorFind.comissaoProdutos !== undefined &&
        vendedorFind.comissaoProdutos.length > 0
      ) {
        listaComissoes = vendedorFind.comissaoProdutos;
      }

      await this.setState({
        pedido: pedidoSaldo,
        vendedor: vendedorFind,
        listaComissoes,
      });
    } else {
      this.props.history.push("/home");
    }
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  //veriicar
  async load(findByDesc, incrementaProdutos = false) {
    // let familia = this.state.filtro.familia;
    // let grupo = this.state.filtro.grupo;
    // let fam = this.state.familia;
    // let grup = this.state.grupo;

    this.setState({ mensagemBusca: "", exibirLoading: true }, async () => {
      let produtosBusca = [];
      let idIntegracoCliente = queryString.parse(
        this.props.location.search
      ).cliente;

      if (this.state.buscaAtivada) {
        findByDesc = true;
      }
      //let filtros = {familia: familia, grupo: grupo, fam: fam, grup: grup};
      if (findByDesc) {
        // await this.setState({ hasMore: false });
        let queryBusca = this.state.queryBusca;

        // if (this.state.tipoPesquisa === "desc") {
        //   queryBusca = "%" + queryBusca;
        // }

        if (this.state.pesquisaProdutoPalavraChave) {
          queryBusca = queryBusca.replace(new RegExp("[%]", "gi"), "");
          queryBusca = "%" + queryBusca;
        }

        produtosBusca = await produtoModel.findByDesc(
          this.state.db,
          idIntegracoCliente,
          queryBusca,
          this.state.buscaPadrao,
          this.state.skip,
          this.state.filtroModal
          // filtros
        );

        // produtosBusca = produtosBusca.map((it) => {
        //   it.estoque.qtd = 0;
        //   return it;
        // });
      } else {
        produtosBusca = await produtoModel.findAll(
          this.state.db,
          idIntegracoCliente,
          this.state.skip,
          this.state.filtroModal
          // filtros
        );

        if (this.state.buscaAtivada) {
          produtosBusca = [];
        }
      }

      for (let produto of produtosBusca) {
        produto.preco.precoUnitComImpostosFinal =
          produto.preco.precoUnitComImpostos;
        produto.preco.pDesconto = 0;
        produto.preco.valorDesconto = 0;
        produto.preco.pAcrescimo = 0;
        produto.preco.valorAcrescimo = 0;

        produto.quantidade = 0;
        produto.quantidadeString = 0;

        let quantidade = 0;
        let itensIdPedido = this.state.pedido.itens.filter(
          (itemPedido) => itemPedido.produto._id === produto._id
        );

        for (let itemId of itensIdPedido) {
          quantidade += parseFloat(itemId.quantidade);
        }

        if (produto.estoque.qtd > 0) {
          produto.estoque.qtd -= quantidade;
        }
      }

      //gambi

      for (let produto of produtosBusca) {
        let precoModal = {};
        precoModal.precoLiquido = parseFloat(
          produto.preco.precoUnitComImpostos.toFixed(2)
        );
        precoModal.valorAcrescimo = 0;
        precoModal.pAcrescimo = 0;
        precoModal.valorDesconto = 0;
        precoModal.pDesconto = 0;
        produto.precoModal = precoModal;
        produto.existeCarrinho = false;
      }

      for (let produto of produtosBusca) {
        produto.comissao = this.getComissaoProduto(produto);
        produto.obsItemNovo = "";
      }

      ///

      if (!incrementaProdutos) {
        if (produtosBusca.length !== 0) {
          this.setState(
            (prevState) => ({
              produtos: produtosBusca,
              skip: prevState.skip + 12,
              exibirLoading: false,
            }),
            () => {
              let pedidoLocal = null;
              if (this.state.actionPage === "CADASTRAR") {
                pedidoLocal = localStorage.getItem("pedido");
              } else if (this.state.actionPage === "EDITAR") {
                pedidoLocal = localStorage.getItem("orcamento");
              }
              pedidoLocal = JSON.parse(pedidoLocal);
              let produtosTeste = this.state.produtos;

              for (let produtoT of produtosTeste) {
                let produtoTFind = pedidoLocal.itens.find(
                  (it) => it.produto._id === produtoT._id
                );

                if (produtoTFind !== undefined) {
                  produtoT.existeCarrinho = true;
                }
              }

              this.setState({ produtos: produtosTeste });
            }
          );
        } else {
          if (this.state.buscaAtivada) {
            this.setState({
              mensagemBusca: ``,
              //mensagemBusca: `Nenhum item foi encontrado com a descrição "${this.state.queryBusca}".`,
              exibirLoading: false,
            });
          }

          this.setState(
            (prevState) => ({
              produtos: produtosBusca,
              skip: prevState.skip + 12,
              hasMore: false,
              exibirLoading: false,
            }),
            () => {
              let pedidoLocal = null;
              if (this.state.actionPage === "CADASTRAR") {
                pedidoLocal = localStorage.getItem("pedido");
              } else if (this.state.actionPage === "EDITAR") {
                pedidoLocal = localStorage.getItem("orcamento");
              }
              pedidoLocal = JSON.parse(pedidoLocal);
              let produtosTeste = this.state.produtos;

              for (let produtoT of produtosTeste) {
                let produtoTFind = pedidoLocal.itens.find(
                  (it) => it.produto._id === produtoT._id
                );

                if (produtoTFind !== undefined) {
                  produtoT.existeCarrinho = true;
                }
              }

              this.setState({ produtos: produtosTeste });
            }
          );
        }
      } else {
        if (produtosBusca.length) {
          this.setState(
            (prevState) => ({
              produtos: [...this.state.produtos, ...produtosBusca],
              skip: prevState.skip + 12,
              exibirLoading: false,
              exibirBotao: true,
            }),
            () => {
              let pedidoLocal = null;
              if (this.state.actionPage === "CADASTRAR") {
                pedidoLocal = localStorage.getItem("pedido");
              } else if (this.state.actionPage === "EDITAR") {
                pedidoLocal = localStorage.getItem("orcamento");
              }
              pedidoLocal = JSON.parse(pedidoLocal);
              let produtosTeste = this.state.produtos;

              for (let produtoT of produtosTeste) {
                let produtoTFind = pedidoLocal.itens.find(
                  (it) => it.produto._id === produtoT._id
                );

                if (produtoTFind !== undefined) {
                  produtoT.existeCarrinho = true;
                }
              }

              this.setState({ produtos: produtosTeste });
            }
          );
        } else {
          this.setState({
            hasMore: false,
            exibirLoading: false,
            exibirBotao: false,
          });
        }
      }
    });
  }

  async onChangePrecoFinal(idProduto, input) {
    let listaProdutos = this.state.produtos;
    let produto = listaProdutos.find((i) => i._id === idProduto);

    if (input === "") {
      input = "0";
    }
    produto.precoModal.precoLiquido = parseFloat(input);
    await this.setState({ listaProdutos }, () => this.calcularTotalCarrinho());
  }

  async onChangeInputModal(value, id) {
    let produtoSelecionado = this.state.produtoSelecionado;

    if (value === "") {
      value = "0";
    }

    produtoSelecionado.precoModal[id] = parseFloat(value);
    await this.setState({ produtoSelecionado, isInputAlterado: true }, () =>
      this.calcularTotalCarrinho()
    );
  }

  handleChangeInputValores(idProduto, input, tipo) {
    if (
      tipo === "VALOR_ACRESCIMO" ||
      tipo === "PORCENTAGEM_ACRESCIMO" ||
      tipo === "VALOR_DESCONTO" ||
      tipo === "PORCENTAGEM_DESCONTO"
    ) {
      if (!this.state.isInputAlterado) {
        return false;
      } else {
        this.setState({ isInputAlterado: false });
      }
    }

    let produtosBusca = this.state.produtos;
    let produto = produtosBusca.find((item) => item._id === idProduto);

    if (input === "") {
      input = "0";
    }

    input = parseFloat(input);
    input = parseFloat(input.toFixed(2));

    let valorAtual = produto.preco.precoUnitComImpostos;
    let tipoEnvio = "";

    switch (tipo) {
      case "VALOR_ACRESCIMO":
        produto.precoModal.precoLiquido = parseFloat(
          (valorAtual + input).toFixed(2)
        );
        produto.precoModal.valorAcrescimo = input;
        produto.precoModal.pAcrescimo = parseFloat(
          ((input * 100) / valorAtual).toFixed(2)
        );
        produto.precoModal.pDesconto = 0;
        produto.precoModal.valorDesconto = 0;
        tipoEnvio = "ACRESCIMO";
        break;

      case "PORCENTAGEM_ACRESCIMO":
        let valor2 = parseFloat(((input * valorAtual) / 100).toFixed(2));
        produto.precoModal.precoLiquido = (valorAtual + valor2).toFixed(2);
        produto.precoModal.pAcrescimo = input;
        produto.precoModal.valorAcrescimo = valor2;
        produto.precoModal.pDesconto = 0;
        produto.precoModal.valorDesconto = 0;
        tipoEnvio = "ACRESCIMO";
        break;

      case "VALOR_DESCONTO":
        produto.precoModal.precoLiquido = parseFloat(
          (valorAtual - input).toFixed(2)
        );
        produto.precoModal.valorDesconto = input;
        produto.precoModal.pDesconto = parseFloat(
          ((input * 100) / valorAtual).toFixed(2)
        );
        produto.precoModal.pAcrescimo = 0;
        produto.precoModal.valorAcrescimo = 0;
        tipoEnvio = "DESCONTO";

        break;

      case "PORCENTAGEM_DESCONTO":
        if (input < 0 || input > 100) return false; //throw new Error('Porcentagem de desconto inválida');
        produto.precoModal.pDesconto = input;
        let valor = parseFloat(((input * valorAtual) / 100).toFixed(2));
        produto.precoModal.precoLiquido = parseFloat(
          (valorAtual - valor).toFixed(2)
        );
        produto.precoModal.valorDesconto = valor;
        produto.precoModal.pAcrescimo = 0;
        produto.precoModal.valorAcrescimo = 0;
        tipoEnvio = "DESCONTO";
        break;

      case "PRECO_LIQUIDO":
        produto.precoModal.precoLiquido = input;

        let diferenca = Math.abs(valorAtual - input);
        diferenca = parseFloat(diferenca.toFixed(2));

        if (input > valorAtual) {
          produto.precoModal.valorAcrescimo = diferenca;
          produto.precoModal.pAcrescimo = parseFloat(
            ((diferenca * 100) / valorAtual).toFixed(2)
          );
          produto.precoModal.pDesconto = 0;
          produto.precoModal.valorDesconto = 0;
          tipoEnvio = "ACRESCIMO";
        } else if (input < valorAtual) {
          produto.precoModal.valorDesconto = diferenca;
          produto.precoModal.pDesconto = parseFloat(
            ((diferenca * 100) / valorAtual).toFixed(2)
          );
          produto.precoModal.pAcrescimo = 0;
          produto.precoModal.valorAcrescimo = 0;
          tipoEnvio = "DESCONTO";
        }
        break;

      default:
        throw new Error("Tipo inválido");
    }

    if (this.state.parametros.tipoDesconto === "over") {
      let teste90 = this.validaDescAcrescimoOver(
        produto._id,
        tipoEnvio,
        produto.precoModal,
        produto.quantidade
      );

      if (teste90.error) {
        produto.precoModal.precoLiquido = parseFloat(
          produto.preco.precoUnitComImpostosFinal.toFixed(2)
        );
        produto.precoModal.valorAcrescimo = produto.preco.valorAcrescimo;
        produto.precoModal.pAcrescimo = produto.preco.pAcrescimo;
        produto.precoModal.valorDesconto = produto.preco.valorDesconto;
        produto.precoModal.pDesconto = produto.preco.pDesconto;

        this.setState(
          {
            produtos: produtosBusca,
            produtoSelecionado: produto,
          },
          () => this.calcularTotalCarrinho()
        );
        this.notificar("warning", teste90.mensagem);
      } else {
        produto.preco.precoUnitComImpostosFinal =
          produto.precoModal.precoLiquido;
        produto.preco.valorAcrescimo = produto.precoModal.valorAcrescimo;
        produto.preco.pAcrescimo = produto.precoModal.pAcrescimo;
        produto.preco.valorDesconto = produto.precoModal.valorDesconto;
        produto.preco.pDesconto = produto.precoModal.pDesconto;

        this.setState(
          {
            produtos: produtosBusca,
            produtoSelecionado: produto,
          },
          () => this.calcularTotalCarrinho()
        );
      }
    } else {
      if (
        parseFloat(produto.precoModal.pDesconto) >
        parseFloat(produto.preco.pDescMax)
      ) {
        this.notificar("warning", "Desconto máximo do produto atingido");

        produto.precoModal.precoLiquido = parseFloat(
          produto.preco.precoUnitComImpostosFinal.toFixed(2)
        );
        produto.precoModal.valorAcrescimo = produto.preco.valorAcrescimo;
        produto.precoModal.pAcrescimo = produto.preco.pAcrescimo;
        produto.precoModal.valorDesconto = produto.preco.valorDesconto;
        produto.precoModal.pDesconto = produto.preco.pDesconto;

        this.setState(
          {
            produtos: produtosBusca,
            produtoSelecionado: produto,
          },
          () => this.calcularTotalCarrinho()
        );
        return false;
      } else {
        produto.preco.precoUnitComImpostosFinal =
          produto.precoModal.precoLiquido;
        produto.preco.valorAcrescimo = produto.precoModal.valorAcrescimo;
        produto.preco.pAcrescimo = produto.precoModal.pAcrescimo;
        produto.preco.valorDesconto = produto.precoModal.valorDesconto;
        produto.preco.pDesconto = produto.precoModal.pDesconto;

        this.setState(
          {
            produtos: produtosBusca,
            produtoSelecionado: produto,
          },
          () => this.calcularTotalCarrinho()
        );
      }
    }
  }

  validaDescAcrescimoOver(idProduto, tipo, preco, quantidade) {
    let produtosQuantidade = this.state.produtos.filter(
      (item) => item.quantidade > 0
    );
    let produtoCarrinho = existeProdutoCarrinho(idProduto, produtosQuantidade);

    let saldoOver = parseFloat(this.state.vendedor.vlOver);

    if (tipo === "ACRESCIMO") {
      if (produtoCarrinho !== null) {
        let tipoAtual = getTipoAtualValor(produtoCarrinho.preco);

        if (tipoAtual === "ACRESCIMO") {
          let saldoAcrescimoAtual =
            produtoCarrinho.quantidade * produtoCarrinho.preco.valorAcrescimo;
          saldoOver -= saldoAcrescimoAtual;
        } else if (tipoAtual === "DESCONTO") {
          let saldoDescontoAtual =
            produtoCarrinho.quantidade * produtoCarrinho.preco.valorDesconto;
          saldoOver += saldoDescontoAtual;
        }

        saldoOver += quantidade * preco.valorAcrescimo;
      } else {
        saldoOver += quantidade * preco.valorAcrescimo;
      }
    } else if (tipo === "DESCONTO") {
      if (produtoCarrinho !== null) {
        let tipoAtual = getTipoAtualValor(produtoCarrinho.preco);

        if (tipoAtual === "ACRESCIMO") {
          let saldoAcrescimoAtual =
            produtoCarrinho.quantidade * produtoCarrinho.preco.valorAcrescimo;
          saldoOver -= saldoAcrescimoAtual;

          let descontoNovo = preco.valorDesconto * quantidade;

          saldoOver -= descontoNovo;

          if (saldoOver < 0) {
            return {
              error: true,
              mensagem: "Não existe saldo over para esse desconto",
            };
          }
        } else if (tipoAtual === "DESCONTO") {
          let saldoDescontoAtual =
            produtoCarrinho.quantidade * produtoCarrinho.preco.valorDesconto;
          saldoOver += saldoDescontoAtual;

          let descontoNovo = preco.valorDesconto * quantidade;

          saldoOver -= descontoNovo;

          if (saldoOver < 0) {
            return {
              error: true,
              mensagem: "Não existe saldo over para esse desconto",
            };
          }
        } else if (tipoAtual === "NONE") {
          let saldoDescontoAtual =
            produtoCarrinho.quantidade * produtoCarrinho.preco.valorDesconto;
          saldoOver += saldoDescontoAtual;

          let descontoNovo = preco.valorDesconto * quantidade;

          saldoOver -= descontoNovo;

          if (saldoOver < 0) {
            return {
              error: true,
              mensagem: "Não existe saldo over para esse desconto",
            };
          }
        }
      } else {
        let descontoNovo = preco.valorDesconto * quantidade;

        saldoOver -= descontoNovo;

        if (saldoOver < 0) {
          return {
            error: true,
            mensagem: "Não existe saldo over para esse desconto",
          };
        }
      }
    }

    let localVendedor = this.state.vendedor;
    localVendedor.vlOver = saldoOver;

    this.setState({ vendedor: localVendedor });

    return {
      error: false,
      mensagem: null,
    };

    function existeProdutoCarrinho(idProduto, teste1) {
      let produto = teste1.find((item) => item._id === idProduto);

      if (produto !== undefined) {
        return Object.assign(produto);
      } else {
        return null;
      }
    }

    function getTipoAtualValor(valores) {
      if (valores.pAcrescimo > 0) {
        return "ACRESCIMO";
      } else if (valores.pDesconto > 0) {
        return "DESCONTO";
      } else {
        return "NONE";
      }
    }
  }

  getTipoAtualValor1(preco) {
    if (preco.pAcrescimo > 0) {
      return "ACRESCIMO";
    } else if (preco.pDesconto > 0) {
      return "DESCONTO";
    } else {
      return "NONE";
    }
  }

  changeBlurQtd(value, id) {
    let localProdutos = this.state.produtos;

    if (value === "") {
      value = "0";
    }

    for (let produto of localProdutos) {
      if (produto._id === id) {
        produto.quantidadeString = parseFloat(value);
        if (produto.fracionado !== undefined && !produto.fracionado) {
          produto.quantidadeString = parseInt(produto.quantidadeString);
        }
      }
    }
    this.setState({ produtos: localProdutos }, () => {
      this.calcularTotalCarrinho();
    });
  }

  handleChangeQtd(value, id, setarPeloHistorico = false) {
    localStorage.setItem("existeProdutoAdicionado", "true");
    let localProdutos = this.state.produtos;
    let localVendedor = this.state.vendedor;

    if (value === "") {
      value = "0";
    }

    for (let produto of localProdutos) {
      if (produto._id === id) {
        let quantidadeInput = parseFloat(value);

        if (produto.fracionado !== undefined && !produto.fracionado) {
          quantidadeInput = parseInt(quantidadeInput);
        }

        let quantidadeInputValida = true;

        if (VALIDAR_ESTOQUE && quantidadeInput > produto.estoque.qtd) {
          if (setarPeloHistorico) {
            quantidadeInput = produto.estoque.qtd;
          } else {
            quantidadeInputValida = false;
          }
        }

        if (quantidadeInputValida) {
          if (
            produto.quantidade !== 0 &&
            produto.quantidade !== quantidadeInput &&
            this.state.parametros.tipoDesconto === "over"
          ) {
            let tipoAtual = this.getTipoAtualValor1(produto.preco);

            let saldoOver = parseFloat(this.state.vendedor.vlOver);

            if (tipoAtual === "ACRESCIMO") {
              let diferenca = Math.abs(produto.quantidade - quantidadeInput);
              if (produto.quantidade < quantidadeInput) {
                saldoOver += diferenca * produto.preco.valorAcrescimo;
              } else {
                saldoOver -= diferenca * produto.preco.valorAcrescimo;
              }
            } else if (tipoAtual === "DESCONTO") {
              let diferenca = Math.abs(produto.quantidade - quantidadeInput);

              if (produto.quantidade < quantidadeInput) {
                saldoOver -= diferenca * produto.preco.valorDesconto;
                if (saldoOver < 0) {
                  this.notificar("warning", "Não existe saldo over disponível");
                  this.setState({ produtos: localProdutos }, () => {
                    this.calcularTotalCarrinho();
                  });
                  return false;
                }
              } else {
                saldoOver += diferenca * produto.preco.valorDesconto;
              }
            }

            let localVendedor = this.state.vendedor;
            localVendedor.vlOver = saldoOver;
            this.setState({ vendedor: localVendedor }, () => {
              this.calcularTotalCarrinho();
            });
          }

          if (quantidadeInput === 0) {
            produto.preco.pAcrescimo = 0;
            produto.preco.valorAcrescimo = 0;
            produto.preco.pDesconto = 0;
            produto.preco.valorDesconto = 0;
            produto.preco.precoUnitComImpostosFinal =
              produto.preco.precoUnitComImpostos;

            produto.precoModal.pAcrescimo = 0;
            produto.precoModal.valorAcrescimo = 0;
            produto.precoModal.pDesconto = 0;
            produto.precoModal.valorDesconto = 0;
            produto.precoModal.precoLiquido = parseFloat(
              produto.preco.precoUnitComImpostos.toFixed(2)
            );
          }
          produto.quantidade = quantidadeInput;
          produto.quantidadeString = quantidadeInput;
        } else {
          produto.quantidadeString = produto.quantidade;
          this.notificar(
            "warning",
            "Digite uma quantidade válida conforme estoque"
          );
        }
      }
    }
    this.setState({ produtos: localProdutos }, () => {
      this.calcularTotalCarrinho();
    });
  }

  adicionarItens() {
    let produtosAdicionar = this.state.produtos;

    // if (
    //   this.state.vendedor.vlOver < 0 &&
    //   this.state.parametros.tipoDesconto === "over"
    // ) {
    //   this.notificar(
    //     "warning",
    //     "Valor negativo para o saldo over, favor analisar itens."
    //   );
    //   return false;
    // }

    produtosAdicionar = produtosAdicionar.filter((prod) => prod.quantidade > 0);

    produtosAdicionar = produtosAdicionar.map((item) => {
      let newItem = {};

      newItem.produto = {
        idIntegracao: item.idIntegracao,
        desc: item.desc,
        cod: item.cod,
        _id: item._id,
        preco: {
          idIntegracao: item.preco.idIntegracao,
          precoUnit: item.preco.precoUnit,
          precoUnitComImpostos: item.preco.precoUnitComImpostos,
          precoUnitComImpostosFinal: item.preco.precoUnitComImpostosFinal,
          pDesconto: item.preco.pDesconto,
          valorDesconto: item.preco.valorDesconto,
          pAcrescimo: item.preco.pAcrescimo,
          valorAcrescimo: item.preco.valorAcrescimo,
          isPromo: item.preco.isPromo,
          embPadrao: item.preco.embPadrao,
        },
        imagemPrincipal: item.imagemPrincipal,
        unid: item.unid,
        giro: item.giro,
        isNovo: item.isNovo,
        comissao: item.comissao !== undefined ? item.comissao : 0,
        obsItemNovo: item.obsItemNovo,
      };

      newItem.quantidade = item.quantidade;
      return newItem;
    });

    let localPedido = Object.assign({}, this.state.pedido);
    localPedido.itens = localPedido.itens.concat(produtosAdicionar);
    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(localPedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(localPedido));
    }
    this.props.history.goBack();
  }

  handleFocus(event) {
    event.target.select();
  }

  onChangeQueryBusca(e) {
    let value = e.target.value;
    this.setState({ queryBusca: value });
  }

  async buscar() {
    if (this.state.queryBusca === "") {
      return false;
    }

    // if (this.state.queryBusca.length < 2) {
    //   this.notificar(
    //     "warning",
    //     "Para pesquisar informe pelo menos 2 caracteres."
    //   );
    //   return false;
    // }

    let produtosAdicionar = this.state.produtos;

    if (
      this.state.vendedor.vlOver < 0 &&
      this.state.parametros.tipoDesconto === "over"
    ) {
      this.notificar(
        "warning",
        "Valor negativo para o saldo over, favor analisar itens."
      );
      return false;
    }

    produtosAdicionar = produtosAdicionar.filter((prod) => prod.quantidade > 0);
    produtosAdicionar = produtosAdicionar.map((item) => {
      let newItem = {};

      newItem.produto = {
        idIntegracao: item.idIntegracao,
        desc: item.desc,
        cod: item.cod,
        _id: item._id,
        preco: {
          idIntegracao: item.preco.idIntegracao,
          precoUnit: item.preco.precoUnit,
          precoUnitComImpostos: item.preco.precoUnitComImpostos,
          precoUnitComImpostosFinal: item.preco.precoUnitComImpostosFinal,
          pDesconto: item.preco.pDesconto,
          valorDesconto: item.preco.valorDesconto,
          pAcrescimo: item.preco.pAcrescimo,
          valorAcrescimo: item.preco.valorAcrescimo,
          isPromo: item.preco.isPromo,
          embPadrao: item.preco.embPadrao,
        },
        imagemPrincipal: item.imagemPrincipal,
        unid: item.unid,
        giro: item.giro,
        isNovo: item.isNovo,
        comissao: item.comissao !== undefined ? item.comissao : 0,
        obsItemNovo: item.obsItemNovo,
      };

      newItem.quantidade = item.quantidade;
      return newItem;
    });

    let localPedido = Object.assign({}, this.state.pedido);
    localPedido.itens = localPedido.itens.concat(produtosAdicionar);

    await this.setState({ pedido: localPedido }, () => {
      if (this.state.actionPage === "CADASTRAR") {
        localStorage.setItem("pedido", JSON.stringify(localPedido));
      } else if (this.state.actionPage === "EDITAR") {
        localStorage.setItem("orcamento", JSON.stringify(localPedido));
      }
      this.setState(
        {
          buscaAtivada: true,
          skip: 0,
          hasMore: true,
          produtos: [],
        },
        () => this.load(true)
      );
    });
  }

  async limparBusca() {
    await this.setState(
      {
        skip: 0,
        buscaAtivada: false,
        queryBusca: "",
        hasMore: true,
      },
      () => {
        this.load(false);
        localStorage.setItem("existeProdutoAdicionado", "false");
      }
    );
  }

  handleClickValores(produto) {
    if (produto.quantidade === 0) {
      this.notificar("warning", "Para manipular o preço, digite a quantidade.");
    } else {
      this.setState(
        {
          produtoSelecionado: produto,
        },
        () => {
          this.toggle();
        }
      );
    }
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  abrirProdutoDetalhe(idProduto) {
    window.open(`/produtos/destaque-detalhe?id=${idProduto}`, "_blank");
  }

  onClickButtonQtd(produto, tipo) {
    if (tipo === "INCREMENTAR") {
      let emb = parseFloat(produto.preco.embPadrao);
      if (emb === 0) emb = 1;
      let valor = produto.quantidade + emb;
      this.handleChangeQtd(valor, produto._id);
    } else if (tipo === "DECREMENTAR") {
      let emb = parseFloat(produto.preco.embPadrao);
      if (emb === 0) emb = 1;

      if (produto.quantidade > 0 && produto.quantidade >= emb) {
        let valor = produto.quantidade - emb;
        if (valor < 0) valor = 0;
        this.handleChangeQtd(valor, produto._id);
      }
    }
  }

  calcularTotalCarrinho() {
    let produtosAdicionar = this.state.produtos;
    let valorTotalCarrinho = 0;
    let pedido = this.state.pedido;

    for (let item of produtosAdicionar) {
      if (item.quantidade > 0) {
        let valor = item.preco.precoUnitComImpostosFinal;
        let condPagto = this.state.pedido.condPagto;
        let desconto = this.state.pedido.desconto;

        if (this.state.parametros.tipoDesconto === "progressivo") {
          if (desconto !== null && desconto.pDesc !== 0) {
            valor = this.calcularValorDesconto(valor, desconto.pDesc);
          }
        } else {
          if (condPagto !== null && condPagto.pDesc !== 0) {
            valor = this.calcularValorDesconto(valor, condPagto.pDesc);
          }
        }

        valor = valor * item.quantidade;
        valorTotalCarrinho += valor;
        item.valorTotalItem = valor;
      }
    }

    if (pedido !== null) {
      for (let item of pedido.itens) {
        let valor = item.produto.preco.precoUnitComImpostosFinal;
        let condPagto = pedido.condPagto;
        let desconto = pedido.desconto;

        if (this.state.parametros.tipoDesconto === "progressivo") {
          if (desconto !== null && desconto.pDesc !== 0) {
            valor = this.calcularValorDesconto(valor, desconto.pDesc);
          }
        } else {
          if (condPagto !== null && condPagto.pDesc !== 0) {
            valor = this.calcularValorDesconto(valor, condPagto.pDesc);
          }
        }

        valor = valor * item.quantidade;
        valorTotalCarrinho += valor;
      }
    }

    this.setState({ valorTotalCarrinho, produtos: produtosAdicionar });
  }

  calcularValorDesconto(valor, porcentagemDesconto) {
    valor = parseFloat(valor.toFixed(2));
    return valor - valor * (porcentagemDesconto / 100);
  }

  async carregarHistoricoProduto(produto) {
    let idIntegracoCliente = queryString.parse(
      this.props.location.search
    ).cliente;

    let historico = await historicoPedidoModel.find(
      this.state.db,
      produto.idIntegracao,
      parseInt(idIntegracoCliente)
    );

    if (historico === null) {
      produto.historicoVazio = true;

      let produtos = this.state.produtos;

      for (let item of produtos) {
        if (produto.idIntegracao === item.idIntegracao) {
          item = produto;
          break;
        }
      }

      this.setState({ produtos });
    } else {
      produto.ultimoPedido = historico;

      let produtos = this.state.produtos;

      for (let item of produtos) {
        if (produto.idIntegracao === item.idIntegracao) {
          item = produto;
          break;
        }
      }

      this.setState({ produtos });
    }
  }

  onDetected = (result) => {
    let cliente = queryString.parse(this.props.location.search).cliente;
    window.location.href = `/adicionar/itens?cliente=${cliente}&busca=cdbarras&codigo=${result}`;
  };

  // async handleChangeFiltro(filtro, type){
  //   let filtros = this.state.filtro;
  //   if(type == "familia")
  //     this.setState({ filtro: {familia: filtro, grupo: filtros.grupo }}, () => this.load(true));
  //   if(type == "grupo")
  //     this.setState({ filtro: {grupo: filtro, familia: filtros.familia }}, () => this.load(true));
  // }

  // toggleProduto() {
  //   this.setState((prevState) => ({
  //     modalFilter: !prevState.modalFilter,
  //   }));
  //   this.buscar();
  // }

  // async clearFilters(){
  //   this.setState({
  //     filtro: { familia: false, grupo: false},
  //     familia: null,
  //     grupo: null
  //   });
  // }

  // async onChangeFilters(e, type) {
  //   if(type == 'familia'){
  //     this.setState({
  //       familia: e,
  //       buscaAtivada: true,
  //         skip: 0,
  //         hasMore: true,
  //         produtos: []
  //     }, () => this.load(true));
  //   }
  //   if(type == 'grupo'){
  //     this.setState({grupo: e,
  //       buscaAtivada: true,
  //       skip: 0,
  //       hasMore: true,
  //       produtos: []}, () => this.load(true));
  //   }
  // }

  async loadFamiliasProduto() {
    let familias = await familiaProdutoModel.findAll(this.state.db);
    familias = familias.map((familia) => {
      familia.value = familia.idIntegracao;
      familia.label = familia.descricao;
      return familia;
    });
    await this.setState({ familias });
  }

  async loadGruposProduto() {
    let grupos = await grupoProdutoModel.findAll(this.state.db);
    grupos = grupos.map((grupo) => {
      grupo.value = grupo.idIntegracao;
      grupo.label = grupo.descricao;
      return grupo;
    });
    await this.setState({ grupos });
  }

  toggleModalFiltro() {
    this.setState({ modalFiltro: !this.state.modalFiltro });
  }

  handleChangeFiltro(item, tipo) {
    let filtroModal = this.state.filtroModal;
    filtroModal[tipo] = item;
    this.setState({ filtroModal });
  }

  async limparFiltros() {
    this.setState(
      {
        filtroModal: {
          familia: null,
          grupo: null,
        },
      },
      async () => {
        await this.setState(
          {
            skip: 0,
            buscaAtivada: false,
            hasMore: true,
          },
          () => {
            this.toggleModalFiltro();
            if (this.state.queryBusca === "") {
              this.load(false);
            } else {
              this.load(true);
            }
          }
        );
      }
    );
  }

  async salvarFiltro() {
    await this.setState(
      {
        skip: 0,
        hasMore: true,
      },
      () => {
        this.toggleModalFiltro();
        if (this.state.queryBusca === "") {
          this.load(false);
        } else {
          this.load(true);
        }
      }
    );
  }

  handleClickFiltrar() {
    this.toggleModalFiltro();
  }

  getComissaoProduto(produto) {
    let idFamilia = produto.idFamilia;
    let idGrupo = produto.idGrupo;
    let listaComissoes = this.state.listaComissoes;

    let comissao = 0;

    if (listaComissoes.length === 0) return 0;

    for (let itemLista of listaComissoes) {
      if (itemLista.tipo === "familia") {
        for (let itemComissao of itemLista.itens) {
          if (idFamilia === itemComissao.idIntegracao) {
            comissao = itemComissao.comissao;
          }
        }
      }
    }

    if (comissao === 0) {
      for (let itemLista of listaComissoes) {
        if (itemLista.tipo === "grupo") {
          for (let itemComissao of itemLista.itens) {
            if (idGrupo === itemComissao.idIntegracao) {
              comissao = itemComissao.comissao;
            }
          }
        }
      }
    }

    return comissao;

    // let vendedor = { //EXEMPLO
    //   type:"vendedor",
    //   comissaoProdutos: [ //ESTE AQUI VAI PARA O STATE, this.state.listaComissoes
    //     {
    //       tipo: "grupo",
    //       itens: [
    //         {
    //           idIntegracao: 111,
    //           comissao: 20
    //         }
    //       ]
    //     }
    //   ]
    // }
  }

  toggleModalObsItem() {
    this.setState({ modalObsItem: !this.state.modalObsItem });
  }

  handleClickObsItemNovo(produto) {
    this.setState(
      {
        idProdutoSelecionadoObs: produto._id,
        obsItemSelecionado: produto.obsItemNovo,
      },
      () => {
        this.toggleModalObsItem();
      }
    );
  }

  handleChangeInputObsItemNovo(value) {
    this.setState({
      obsItemSelecionado: value,
    });
  }

  handleClickSalvarObsItemNovo() {
    let produtos = this.state.produtos;
    for (let item of produtos) {
      if (item._id === this.state.idProdutoSelecionadoObs) {
        item.obsItemNovo = this.state.obsItemSelecionado;
      }
    }

    this.setState(
      { produtos, idProdutoSelecionadoObs: null, obsItemSelecionado: "" },
      () => {
        this.toggleModalObsItem();
      }
    );
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao-pedidos`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Carrinho de vendas" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"novoPedido"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title={`Cadastrar Pedido`}
                  description="Adicionar um novo pedido"
                /> */}

                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div className="row">
                                  <React.Fragment>
                                    <div className="container">
                                      <div className="container-pesquisa-add-itens d-flex">
                                        {/* <div
                  className="col-2 no-padding d-flex"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#000",
                    fontSize: "22px",
                    cursor: "pointer",
                    marginTop: "5px",
                    color: "#434343",
                  }}
                  onClick={(e) =>
                    this.setState({
                      abaAtiva: "camera",
                      camera: true,
                      buscaPadrao: "cdBarras",
                    })
                  }
                >
                  <i className="fa fa-camera"></i>
                </div> */}
                                        <div
                                          className="col-8 no-padding"
                                          style={{ position: "relative" }}
                                        >
                                          <input
                                            type="text"
                                            className="form-control font-13"
                                            // placeholder={
                                            //   this.state.vendedor !== null
                                            //     ? this.state.tipoPesquisa ===
                                            //       "cod"
                                            //       ? "Pesquise pelo código"
                                            //       : "Pesquise pela desc"
                                            //     : ""
                                            // }

                                            placeholder={
                                              this.state.vendedor !== null
                                                ? this.state
                                                    .pesquisaProdutoPalavraChave
                                                  ? "Pesquise por palavra chave..."
                                                  : "Pesquise pela desc completa..."
                                                : ""
                                            }
                                            style={{
                                              boxShadow:
                                                "0px 2px 5px 0px #999999",
                                            }}
                                            value={this.state.queryBusca}
                                            onChange={this.onChangeQueryBusca}
                                            onKeyPress={(e) => {
                                              if (e.key === "Enter") {
                                                this.buscar();
                                              }
                                            }}
                                          />

                                          {/* <small
                                            style={{
                                              float: "left",
                                              width: "100%",
                                              textAlign: "right",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              let tipoPesquisa = "";

                                              if (
                                                this.state.tipoPesquisa ===
                                                "cod"
                                              ) {
                                                tipoPesquisa = "desc";
                                              } else {
                                                tipoPesquisa = "cod";
                                              }
                                              this.setState(
                                                { tipoPesquisa },
                                                () => {
                                                  localStorage.setItem(
                                                    "tipoPesquisa",
                                                    tipoPesquisa
                                                  );
                                                  this.limparBusca();
                                                }
                                              );
                                            }}
                                          >
                                            Trocar pesquisa para{" "}
                                            {this.state.tipoPesquisa === "cod"
                                              ? `"DESC"`
                                              : `"COD"`}
                                          </small> */}

                                          {this.state.buscaAtivada && (
                                            <div
                                              style={{
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "#7c3e7a",
                                                fontSize: "25px",
                                                cursor: "pointer",
                                                position: "absolute",
                                                right: "10px",
                                                top: "6px",
                                              }}
                                              onClick={() => {
                                                this.setState(
                                                  { buscaPadrao: "descricao" },
                                                  () => {
                                                    this.limparBusca();
                                                  }
                                                );
                                              }}
                                              className="d-flex"
                                            >
                                              <i className="fa fa-times"></i>
                                            </div>
                                          )}
                                        </div>

                                        <div
                                          className="col-2 no-padding d-flex"
                                          style={{ justifyContent: "" }}
                                        >
                                          <span
                                            onClick={() => {
                                              // this.setState({ filtroModal: this.state.filtro }, () => {

                                              // });

                                              this.handleClickFiltrar();
                                            }}
                                            className="fa fa-filter fa-2x"
                                            style={{
                                              marginTop: "3px",
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                            }}
                                          ></span>
                                        </div>
                                      </div>
                                      {/* container-pesquisa-add-itens */}
                                    </div>{" "}
                                    {/* container */}
                                    {this.state.mensagemBusca !== "" && (
                                      <div className="float-left width-100 d-flex">
                                        <div className="container float-left width-100 text-center font-13">
                                          {this.state.mensagemBusca}
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      className="container-itens"
                                      style={{
                                        float: "left",
                                        width: "100%",
                                        paddingBottom: "65px",
                                        // backgroundColor: this.state.produtos
                                        //   .length
                                        //   ? "rgb(217, 217, 217)"
                                        //   : "white",
                                      }}
                                    >
                                      <div
                                        className="container d-flex"
                                        style={{ flexWrap: "wrap" }}
                                      >
                                        {this.state.produtos.map((produto) => (
                                          // <div
                                          //   className="owl-item active"
                                          //  // style={{ width: "228px" }}
                                          // >

                                          <React.Fragment>
                                            <div className="col-md-3 product-list__item-home">
                                              <article className="product-variation">
                                                {/* <div style={{position:"relative"}}> */}
                                                <figure className="product-variation__figure text-center">
                                                  <a
                                                    className="product-variation__image-container link-teste"
                                                    // href="#"
                                                    target="_blank"
                                                    // onClick={() => {
                                                    //   this.props.history.push(
                                                    //     `/produtos/destaque-detalhe?id=${produto._id}`
                                                    //   );
                                                    // }}
                                                    onClick={() => {
                                                      this.abrirProdutoDetalhe(
                                                        produto._id
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      //src="../images/no-image.png"
                                                      src={
                                                        produto.imagemPrincipal
                                                      }
                                                      // src={
                                                      //   produto.imagemPrincipal
                                                      // }
                                                      className="product-variation__image"
                                                      id="img-34883"
                                                      loading="lazy"
                                                      style={{
                                                        width: "150px",
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  </a>
                                                </figure>
                                                {/* 
                                                <span
                                                          style={{
                                                            fontSize: "18px",
                                                            position:
                                                              "relative",
                                                            color: "#7c3e7a",
                                                            paddingLeft: "5px",
                                                            top: "1px"
                                                          }}
                                                        >
                                                          <i className="fa fa-cart-arrow-down"></i>
                                                        </span> */}

                                                {/* </div> */}
                                                <div className="product-variation__details">
                                                  <a
                                                    className="product-variation__name link-teste"
                                                    // href="#"
                                                    target="_blank"
                                                    // onClick={() => {
                                                    //   this.props.history.push(
                                                    //     `/produtos/destaque-detalhe?id=${produto._id}`
                                                    //   );
                                                    // }}
                                                    onClick={() => {
                                                      this.abrirProdutoDetalhe(
                                                        produto._id
                                                      );
                                                    }}
                                                    style={{
                                                      color: "#333",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <span
                                                      className="float-left w-100"
                                                      style={{
                                                        color: "#5f9f1a",
                                                        fontWeight: "bold",
                                                        display: "block",
                                                      }}
                                                    >
                                                      #{produto.cod} -{" "}
                                                      {produto.desc}
                                                      {produto.existeCarrinho && (
                                                        <span
                                                          style={{
                                                            fontSize: "18px",
                                                            position:
                                                              "relative",
                                                            color: "#7c3e7a",
                                                            paddingLeft: "5px",
                                                            top: "1px",
                                                          }}
                                                        >
                                                          <i className="fa fa-cart-arrow-down"></i>
                                                        </span>
                                                      )}
                                                    </span>
                                                  </a>
                                                </div>
                                                <div
                                                  className="product-variation__details float-left w-100"
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <div className="product-variation__price float-left w-100">
                                                    <span className="product-variation__final-price">
                                                      Estoque:{" "}
                                                      <span
                                                        style={{
                                                          color:
                                                            produto.estoque
                                                              .qtd === 0
                                                              ? "red"
                                                              : "inherit",
                                                          fontWeight:
                                                            produto.estoque
                                                              .qtd === 0
                                                              ? "bold"
                                                              : "normal",
                                                        }}
                                                      >
                                                        {produto.estoque.qtd}{" "}
                                                        {produto.unid}
                                                      </span>
                                                      <br />
                                                    </span>
                                                    <span className="product-variation__final-price">
                                                      Embalagem:{" "}
                                                      {produto.preco.embPadrao}{" "}
                                                      {produto.unid}
                                                    </span>
                                                    <br />
                                                    <div className="product-variation__final-price">
                                                      Preço padrão:{" "}
                                                      <span
                                                        style={{
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        R${" "}
                                                        {formatarReal(
                                                          produto.preco
                                                            .precoUnitComImpostos
                                                        )}
                                                      </span>
                                                      <br />
                                                      <div
                                                        className="d-flex"
                                                        style={{
                                                          marginTop: "5px",
                                                          justifyContent:
                                                            "center",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            color: "green",
                                                          }}
                                                        >
                                                          R${" "}
                                                          {formatarReal(
                                                            produto.preco
                                                              .precoUnitComImpostos
                                                          )}
                                                        </span>
                                                        <span
                                                          className="font-13 width-100 no-border-radius btn-negociar btn-negociar-new2"
                                                          onClick={(e) =>
                                                            this.handleClickValores(
                                                              produto
                                                            )
                                                          }
                                                          disabled={
                                                            this.state
                                                              .usuario === null
                                                              ? true
                                                              : this.state
                                                                  .parametros
                                                                  .tipoDesconto ===
                                                                "progressivo"
                                                              ? true
                                                              : false
                                                          }
                                                        >
                                                          <i
                                                            className="fa fa-edit"
                                                            style={{
                                                              fontSize: "17px",
                                                              cursor: "pointer",
                                                              marginTop: "3px",
                                                            }}
                                                          ></i>
                                                        </span>
                                                        <span
                                                          className="font-13 width-100 no-border-radius btn-negociar btn-negociar-new2"
                                                          onClick={(e) =>
                                                            this.handleClickObsItemNovo(
                                                              produto
                                                            )
                                                          }
                                                        >
                                                          <i
                                                            className="fa fa-commenting-o"
                                                            style={{
                                                              fontSize: "17px",
                                                              cursor: "pointer",
                                                              marginTop: "3px",
                                                            }}
                                                          ></i>
                                                        </span>
                                                      </div>
                                                      {/* <div>
                                                        Valor total: R$0,00
                                                      </div> */}
                                                    </div>

                                                    {/* <div className="product-variation__fractional-desc">
                                                      <span>
                                                        Preço por Unidade R$
                                                        2,127
                                                      </span>
                                                    </div> */}
                                                  </div>
                                                </div>

                                                <div
                                                  className="product-variation__actions"
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <div
                                                    className="product-actions"
                                                    data-variant-id="34883"
                                                    data-compra-minima="1"
                                                    data-multiplos="1"
                                                    data-stock="14"
                                                    data-compra-maxima=""
                                                    data-is-fractional="0"
                                                    data-price="6.38"
                                                  >
                                                    <div className="col-xs-12 no-padding">
                                                      <div className="product-variation__add-actions product-add-actions product-add-actions-34883">
                                                        <div className="float-left width-100 d-flex">
                                                          <div className="col-7 no-padding">
                                                            <input
                                                              type="number"
                                                              inputMode="decimal"
                                                              min="0"
                                                              value={
                                                                produto.quantidadeString
                                                              }
                                                              onBlur={(e) => {
                                                                this.handleChangeQtd(
                                                                  e.target
                                                                    .value,
                                                                  produto._id
                                                                );
                                                              }}
                                                              onChange={(e) =>
                                                                this.changeBlurQtd(
                                                                  e.target
                                                                    .value,
                                                                  produto._id
                                                                )
                                                              }
                                                              disabled={
                                                                VALIDAR_ESTOQUE
                                                                  ? produto
                                                                      .estoque
                                                                      .qtd === 0
                                                                    ? true
                                                                    : false
                                                                  : false
                                                              }
                                                              onFocus={
                                                                this.handleFocus
                                                              }
                                                              className={
                                                                "form-control teste21"
                                                              }
                                                            />
                                                          </div>
                                                          <div
                                                            className="col-5"
                                                            style={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "center",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <span
                                                              className="span-qtd float-left"
                                                              style={{
                                                                backgroundColor:
                                                                  "#DC494A",
                                                                width: "90%",
                                                                marginRight:
                                                                  "3px",
                                                                textAlign:
                                                                  "center",
                                                              }}
                                                              onClick={(e) => {
                                                                if (
                                                                  VALIDAR_ESTOQUE
                                                                ) {
                                                                  if (
                                                                    produto
                                                                      .estoque
                                                                      .qtd > 0
                                                                  ) {
                                                                    this.onClickButtonQtd(
                                                                      produto,
                                                                      "DECREMENTAR"
                                                                    );
                                                                  }
                                                                } else {
                                                                  this.onClickButtonQtd(
                                                                    produto,
                                                                    "DECREMENTAR"
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              <i className="fa fa-minus" />
                                                            </span>

                                                            <span
                                                              className="span-qtd float-left"
                                                              style={{
                                                                backgroundColor:
                                                                  "#7ED321",
                                                                width: "90%",
                                                                marginRight:
                                                                  "10%",
                                                                textAlign:
                                                                  "center",
                                                              }}
                                                              onClick={(e) => {
                                                                if (
                                                                  VALIDAR_ESTOQUE
                                                                ) {
                                                                  if (
                                                                    produto
                                                                      .estoque
                                                                      .qtd > 0
                                                                  ) {
                                                                    this.onClickButtonQtd(
                                                                      produto,
                                                                      "INCREMENTAR"
                                                                    );
                                                                  }
                                                                } else {
                                                                  this.onClickButtonQtd(
                                                                    produto,
                                                                    "INCREMENTAR"
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              <i className="fa fa-plus" />
                                                            </span>
                                                          </div>
                                                        </div>

                                                        {/* <button
                                                          id="btn-add-to-cart-34883"
                                                          type="button"
                                                          className="button button-default less-padding product-variation__add-cart product-variation__add-cart-first product-add-34883"
                                                        >
                                                          Adicionar
                                                        </button> */}

                                                        <div
                                                          style={{
                                                            fontSize: 0,
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          <button
                                                            id="btn-qtd-minus-34883"
                                                            type="button"
                                                            className="button button-default less-padding product-variation__add-cart"
                                                            data-operation="-"
                                                            style={{
                                                              display: "none",
                                                            }}
                                                          >
                                                            -
                                                          </button>
                                                          <button
                                                            id="btn-qtd-plus-34883"
                                                            type="button"
                                                            className="button button-default less-padding product-variation__add-cart"
                                                            data-operation="+"
                                                            style={{
                                                              display: "none",
                                                            }}
                                                          >
                                                            +
                                                          </button>
                                                        </div>

                                                        <button
                                                          id="btn-update-qtd-cart-34883"
                                                          type="button"
                                                          className="button button-default less-padding product-variation__add-cart product-variation__add-cart-update product-add-34883"
                                                          style={{
                                                            display: "none",
                                                          }}
                                                        >
                                                          Atualizar
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </article>{" "}
                                            </div>

                                            {/* </div>
                                             */}
                                          </React.Fragment>
                                        ))}

                                        {this.state.produtos.length > 0 && (
                                          <div
                                            className="float-left w-100 text-center"
                                            style={{ marginTop: "20px" }}
                                          >
                                            {this.state.exibirBotao && (
                                              <span
                                                className=""
                                                onClick={() =>
                                                  this.load(true, true)
                                                }
                                                style={{
                                                  textDecoration: "underline",
                                                  cursor: "pointer",
                                                  float: "left",
                                                  width: "100%",
                                                  paddingBottom: "50px",
                                                  fontSize: "15px",
                                                }}
                                              >
                                                Carregar mais
                                                {this.state.exibirLoading && (
                                                  <img
                                                    src="./images/loading-produtos.gif"
                                                    style={{
                                                      width: "20px",
                                                      marginLeft: "3px",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}

                                            <button
                                              className="btn btn-success btn-app-pedidos"
                                              onClick={() =>
                                                this.adicionarItens()
                                              }
                                            >
                                              ADICIONAR ITENS
                                            </button>
                                          </div>
                                        )}

                                        {/* <button
                                          onClick={() => this.adicionarItens()}
                                        >
                                          feleip
                                        </button> */}
                                      </div>
                                    </div>
                                    <Modal
                                      isOpen={this.state.modalFiltro}
                                      toggle={this.toggleModalFiltro}
                                    >
                                      <ModalHeader>Aplicar filtros</ModalHeader>
                                      <ModalBody>
                                        <div className="row">
                                          <div className="col-lg-12 form-input">
                                            <div className=" form-group setting-top">
                                              <label
                                                for="exampleEmail space-label"
                                                className="label-form"
                                              >
                                                Pesquisa por palavra chave:
                                              </label>
                                              <Select
                                                placeholder="Selecione"
                                                value={
                                                  this.state.opcaoSelecionada
                                                }
                                                onChange={(item) => {
                                                  let pesquisaProdutoPalavraChave =
                                                    item.value === "1"
                                                      ? true
                                                      : false;
                                                  this.setState(
                                                    {
                                                      opcaoSelecionada: item,
                                                      pesquisaProdutoPalavraChave,
                                                    },
                                                    () => {
                                                      localStorage.setItem(
                                                        "pesquisaProdutoPalavraChave",
                                                        pesquisaProdutoPalavraChave
                                                      );
                                                    }
                                                  );
                                                }}
                                                options={this.state.opcoes}
                                              />
                                            </div>

                                            <div className=" form-group setting-top">
                                              <label
                                                for="exampleEmail space-label"
                                                className="label-form"
                                              >
                                                Família:
                                              </label>
                                              <Select
                                                value={
                                                  this.state.filtroModal.familia
                                                }
                                                onChange={(item) =>
                                                  this.handleChangeFiltro(
                                                    item,
                                                    "familia"
                                                  )
                                                }
                                                options={this.state.familias}
                                              />
                                            </div>
                                          </div>
                                          <div className="col-lg-12 form-input">
                                            <div className=" form-group setting-top">
                                              <label
                                                for="exampleEmail space-label"
                                                className="label-form"
                                              >
                                                Grupo:
                                              </label>
                                              <Select
                                                value={
                                                  this.state.filtroModal.grupo
                                                }
                                                onChange={(item) =>
                                                  this.handleChangeFiltro(
                                                    item,
                                                    "grupo"
                                                  )
                                                }
                                                options={this.state.grupos}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </ModalBody>
                                      <ModalFooter>
                                        <button
                                          className="btn btn-danger"
                                          onClick={(e) => this.limparFiltros()}
                                        >
                                          Limpar
                                        </button>
                                        <button
                                          className="btn btn-success"
                                          onClick={(e) => this.salvarFiltro()}
                                        >
                                          Filtrar
                                        </button>
                                      </ModalFooter>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.modal}
                                      toggle={this.toggle}
                                    >
                                      {this.state.vendedor !== null && (
                                        <React.Fragment>
                                          {this.state.produtoSelecionado !==
                                            null && (
                                            <div
                                              className="modal-header font-size-16"
                                              style={{
                                                backgroundColor: "#7c3e7a",
                                                fontWeight: "bold",
                                                color: "#FFF",
                                              }}
                                            >
                                              Negociação
                                            </div>
                                          )}
                                        </React.Fragment>
                                      )}
                                      <ModalBody>
                                        {this.state.produtoSelecionado !==
                                          null && (
                                          <React.Fragment>
                                            <div
                                              className="col-12 font-13"
                                              style={{
                                                paddingBottom: "15px",
                                                paddingLeft: "0",
                                                paddingRight: "0",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  color: "#5f9f1a",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                #
                                                {
                                                  this.state.produtoSelecionado
                                                    .cod
                                                }
                                              </span>
                                              <br />
                                              {
                                                this.state.produtoSelecionado
                                                  .desc
                                              }
                                            </div>

                                            <div
                                              className="col-12 no-padding d-flex flex-wrap font-13"
                                              style={{
                                                alignItems: "center",
                                                color: "#434343",
                                              }}
                                            >
                                              <div
                                                className="offset-1 col-4"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  textAlign: "right",
                                                }}
                                              >
                                                Preço unit R$:
                                              </div>

                                              <div
                                                className="col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  textAlign: "right",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {formatarReal(
                                                  this.state.produtoSelecionado
                                                    .preco.precoUnitComImpostos
                                                )}
                                              </div>

                                              <div
                                                className="col-4"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                }}
                                              ></div>
                                            </div>

                                            <div
                                              className="col-12 no-padding d-flex flex-wrap font-color-red font-13"
                                              style={{
                                                alignItems: "center",
                                                color: "#DC494A",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              <div
                                                className="offset-2 col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  textAlign: "right",
                                                }}
                                              >
                                                (-) R$:
                                              </div>

                                              <div
                                                className="col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                }}
                                              >
                                                <input
                                                  type="number"
                                                  inputMode="decimal"
                                                  min="0"
                                                  value={
                                                    this.state
                                                      .produtoSelecionado
                                                      .precoModal.valorDesconto
                                                  }
                                                  style={{ textAlign: "right" }}
                                                  onFocus={this.handleFocus}
                                                  className={
                                                    "form-control input-adicionar-itens-modal font-color-red"
                                                  }
                                                  id="valorDesconto"
                                                  onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (value !== "") {
                                                      value = parseFloat(value);
                                                      value = "" + value;
                                                      document.getElementById(
                                                        `valorDesconto`
                                                      ).value = value;
                                                    }
                                                    this.onChangeInputModal(
                                                      value,
                                                      e.target.id
                                                    );
                                                  }}
                                                  onBlur={(e) =>
                                                    this.handleChangeInputValores(
                                                      this.state
                                                        .produtoSelecionado._id,
                                                      e.target.value,
                                                      "VALOR_DESCONTO"
                                                    )
                                                  }
                                                />
                                              </div>

                                              <div
                                                className="col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <input
                                                  type="number"
                                                  inputMode="decimal"
                                                  min="0"
                                                  value={
                                                    this.state
                                                      .produtoSelecionado
                                                      .precoModal.pDesconto
                                                  }
                                                  style={{ textAlign: "right" }}
                                                  onFocus={this.handleFocus}
                                                  className={
                                                    "form-control input-adicionar-itens-modal font-color-red"
                                                  }
                                                  id="pDesconto"
                                                  onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (value !== "") {
                                                      value = parseFloat(value);
                                                      value = "" + value;
                                                      document.getElementById(
                                                        `pDesconto`
                                                      ).value = value;
                                                    }
                                                    this.onChangeInputModal(
                                                      value,
                                                      e.target.id
                                                    );
                                                  }}
                                                  onBlur={(e) =>
                                                    this.handleChangeInputValores(
                                                      this.state
                                                        .produtoSelecionado._id,
                                                      e.target.value,
                                                      "PORCENTAGEM_DESCONTO"
                                                    )
                                                  }
                                                />
                                                <span>%</span>
                                              </div>
                                            </div>

                                            <div
                                              className="col-12 no-padding d-flex flex-wrap font-color-green font-13"
                                              style={{
                                                alignItems: "center",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              <div
                                                className="offset-2 col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  textAlign: "right",
                                                }}
                                              >
                                                (+) R$:
                                              </div>

                                              <div
                                                className="col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                }}
                                              >
                                                <input
                                                  type="number"
                                                  inputMode="decimal"
                                                  min="0"
                                                  value={
                                                    this.state
                                                      .produtoSelecionado
                                                      .precoModal.valorAcrescimo
                                                  }
                                                  style={{ textAlign: "right" }}
                                                  onFocus={this.handleFocus}
                                                  className={
                                                    "form-control input-adicionar-itens-modal font-color-green"
                                                  }
                                                  id="valorAcrescimo"
                                                  onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (value !== "") {
                                                      value = parseFloat(value);
                                                      value = "" + value;
                                                      document.getElementById(
                                                        `valorAcrescimo`
                                                      ).value = value;
                                                    }
                                                    this.onChangeInputModal(
                                                      value,
                                                      e.target.id
                                                    );
                                                  }}
                                                  onBlur={(e) =>
                                                    this.handleChangeInputValores(
                                                      this.state
                                                        .produtoSelecionado._id,
                                                      e.target.value,
                                                      "VALOR_ACRESCIMO"
                                                    )
                                                  }
                                                />
                                              </div>

                                              <div
                                                className="col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <input
                                                  type="number"
                                                  inputMode="decimal"
                                                  min="0"
                                                  value={
                                                    this.state
                                                      .produtoSelecionado
                                                      .precoModal.pAcrescimo
                                                  }
                                                  style={{ textAlign: "right" }}
                                                  onFocus={this.handleFocus}
                                                  className={
                                                    "form-control input-adicionar-itens-modal font-color-green"
                                                  }
                                                  id="pAcrescimo"
                                                  onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (value !== "") {
                                                      value = parseFloat(value);
                                                      value = "" + value;
                                                      document.getElementById(
                                                        `pAcrescimo`
                                                      ).value = value;
                                                    }
                                                    this.onChangeInputModal(
                                                      value,
                                                      e.target.id
                                                    );
                                                  }}
                                                  onBlur={(e) =>
                                                    this.handleChangeInputValores(
                                                      this.state
                                                        .produtoSelecionado._id,
                                                      e.target.value,
                                                      "PORCENTAGEM_ACRESCIMO"
                                                    )
                                                  }
                                                />
                                                <span>%</span>
                                              </div>
                                            </div>

                                            <div
                                              className="col-12 d-flex flex-wrap font-13"
                                              style={{
                                                alignItems: "center",
                                                color: "#434343",
                                                paddingBottom: "15px",
                                                paddingTop: "5px",
                                              }}
                                            >
                                              <div
                                                className="offset-1 col-4"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  textAlign: "right",
                                                }}
                                              >
                                                Preço final R$:
                                              </div>

                                              <div
                                                className="col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  textAlign: "right",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {formatarReal(
                                                  this.state.produtoSelecionado
                                                    .preco
                                                    .precoUnitComImpostosFinal
                                                )}
                                              </div>

                                              <div
                                                className="col-3"
                                                style={{
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                }}
                                              ></div>
                                            </div>

                                            <div
                                              className="col-12 text-center d-flex float-left width-100 font-13"
                                              style={{
                                                borderTop: "1px solid #C0C0C0",
                                                paddingTop: "15px",
                                                alignItems: "center",
                                              }}
                                            >
                                              {this.state.vendedor !== null &&
                                                this.state
                                                  .produtoSelecionado !==
                                                  null &&
                                                this.state.parametros !==
                                                  null &&
                                                this.state.parametros
                                                  .tipoDesconto === "over" && (
                                                  <div
                                                    className="col-4 no-padding"
                                                    style={{ color: "#434343" }}
                                                  >
                                                    Saldo over{" "}
                                                    <span
                                                      className="display-block"
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      R${" "}
                                                      {formatarReal(
                                                        this.state.vendedor !==
                                                          null
                                                          ? this.state.vendedor
                                                              .vlOver
                                                          : 0
                                                      )}
                                                    </span>
                                                  </div>
                                                )}

                                              {this.state.vendedor !== null &&
                                                this.state
                                                  .produtoSelecionado !==
                                                  null &&
                                                this.state.parametros
                                                  .tipoDesconto ===
                                                  "digitado" && (
                                                  <div
                                                    className="col-4 no-padding"
                                                    style={{ color: "#434343" }}
                                                  >
                                                    Desconto máx{" "}
                                                    <span
                                                      className="display-block"
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {this.state.produtoSelecionado.preco.pDescMax
                                                        .toString()
                                                        .replace(".", ",")}
                                                      %
                                                    </span>
                                                  </div>
                                                )}

                                              <div className="col-4 no-padding">
                                                <button
                                                  className="btn btn-secondary"
                                                  style={{
                                                    width: "100%",
                                                    fontSize: "13px",
                                                  }}
                                                  onClick={this.toggle}
                                                >
                                                  Voltar
                                                </button>
                                              </div>

                                              <div
                                                className="col-4 no-padding"
                                                style={{ color: "#434343" }}
                                              >
                                                Total pedido{" "}
                                                <span
                                                  className="display-block"
                                                  style={{ fontWeight: "bold" }}
                                                >
                                                  R${" "}
                                                  {formatarReal(
                                                    this.state
                                                      .valorTotalCarrinho
                                                  )}
                                                </span>
                                              </div>
                                            </div>
                                          </React.Fragment>
                                        )}
                                      </ModalBody>
                                    </Modal>
                                    {/* krause */}
                                    <Modal
                                      isOpen={this.state.modalObsItem}
                                      toggle={this.toggleModalObsItem}
                                    >
                                      <ModalHeader>
                                        Observação do Item
                                      </ModalHeader>
                                      <ModalBody>
                                        <div className="row">
                                          <div className="col-lg-12 form-input">
                                            <div className=" form-group setting-top">
                                              <label className="label-form">
                                                OBS:
                                              </label>
                                              <textarea
                                                className="form-control text-area-height"
                                                rows="4"
                                                onChange={(e) =>
                                                  this.handleChangeInputObsItemNovo(
                                                    e.target.value
                                                  )
                                                }
                                              >
                                                {this.state.obsItemSelecionado}
                                              </textarea>
                                            </div>
                                          </div>
                                        </div>
                                      </ModalBody>
                                      <ModalFooter>
                                        <button
                                          className="btn btn-success"
                                          onClick={(e) =>
                                            this.handleClickSalvarObsItemNovo()
                                          }
                                        >
                                          Salvar
                                        </button>
                                      </ModalFooter>
                                    </Modal>
                                    {/* <div
                                      style={{
                                        backgroundColor: "#f3f3f3",
                                        padding: "15px 0",
                                        position: "fixed",
                                        bottom: 0,
                                        float: "left",
                                        width: "100%",
                                      }}
                                    >
                                      <div className="container">
                                        <div className="col-12 no-padding text-center d-flex float-left width-100 font-13">
                                          {this.state.parametros !== null &&
                                          this.state.parametros.tipoDesconto ===
                                            "over" ? (
                                            <div className="col-4 no-padding">
                                              Saldo over{" "}
                                              <span
                                                className="display-block"
                                                style={{
                                                  color: "#5f9f1a",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                R${" "}
                                                {formatarReal(
                                                  this.state.vendedor !== null
                                                    ? this.state.vendedor.vlOver
                                                    : 0
                                                )}
                                              </span>
                                            </div>
                                          ) : (
                                            <div className="col-4 no-padding"></div>
                                          )}

                                          <div className="col-4 no-padding">
                                            <button
                                              className="btn btn-app-blue font-size-11 btn-adicionar"
                                              style={{
                                                width: "100%",
                                                height: "30px",
                                              }}
                                              onClick={this.adicionarItens}
                                            >
                                              Adicionar
                                            </button>
                                          </div>

                                          <div className="col-4 no-padding">
                                            Valor total
                                            <span
                                              className="display-block"
                                              style={{
                                                color: "#5f9f1a",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              R${" "}
                                              {formatarReal(
                                                this.state.valorTotalCarrinho
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                                  </React.Fragment>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
